import { theme } from "antd";
import { create } from "zustand";
import { persist } from "zustand/middleware";

const initialState = {
  colorPrimary: theme.defaultSeed.colorPrimary,
  collapsed: false,
  fontSize: 16,
};

export const useSettingsStore = create<typeof initialState>()(
  persist(() => initialState, { name: "app-settings" }),
);

export function setColorPrimary(colorPrimary: string) {
  useSettingsStore.setState({ colorPrimary });
}

export function setCollapsed(collapsed: boolean) {
  useSettingsStore.setState({ collapsed });
}
